import React from 'react';
import { View } from 'react-native';
import Details from '../components/Details';

import Extra from '../components/Extra';
import { useRoute } from '@react-navigation/native';
import CartBtn from '../components/CartBtn';

const PopUp = () => {
  const route = useRoute();
  const { restaurant } = route.params || {};

  return (
    <>
      <View>
        <Details restaurant={restaurant} />
        <Extra restaurant={restaurant} />
        <CartBtn restaurant={restaurant} />
      </View>
    </>
  );
};

export default PopUp;
